import axios from 'axios'
import { API_BASE } from '../config'

// Sent when logged in, so the backend can tell whether a profile is the viewer's own
function authHeaders() {
    let token = localStorage.getItem('token');
    return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}

export default class Profile {
    // GET /profile/of/:who - A player's public profile, by username or user id:
    // { id, username, bio, bioMaxLength, joined, isMine, cards: { ...statistics, rarest }, games: { spacejump: [record] } }
    get(who) {
        return axios.get(`${API_BASE}/profile/of/${encodeURIComponent(who)}`, authHeaders()).then(x => x.data);
    }

    // GET /profile/me - The logged-in user's own profile
    getMine() {
        return axios.get(`${API_BASE}/profile/me`, authHeaders()).then(x => x.data);
    }

    // PUT /profile/bio - Set the logged-in user's biography: { success, bio }
    setBio(bio) {
        return axios.put(`${API_BASE}/profile/bio`, { bio }, authHeaders()).then(x => x.data);
    }
}
